import { Box, Typography } from '@mui/material';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { useAuthContext } from '../../contexts/AuthContext';

type RoleCheckerProps = {
 resource: string;
 action: string;
 children: ReactNode;
 showMessage?: boolean;
};

const RoleChecker = ({
 resource,
 action,
 children,
 showMessage = false,
}: RoleCheckerProps) => {
 const { t } = useTranslation();
 const { hasRole } = useAuthContext();

 const hasRequiredRole = hasRole(resource, action);
 const roleName = `${resource}.${action}`;
 return <>{children}</>;
 if (hasRequiredRole) {
  return <>{children}</>;
 }

 if (!showMessage) {
  return <></>;
 }
 return (
  <Box sx={{ p: '20px' }}>
   <Typography
    sx={{
     fontSize: 14,
     fontWeight: 400,
     color: (theme) => theme.palette.kemek.darkGray,
    }}
   >
    {t('global.missingRoleMessage', { roleName })}
   </Typography>
  </Box>
 );
};

export default RoleChecker;
